import strikethrough from '../../icons/strikethrough.svg'

export default {
  name: 'strikethrough',
  title: '删除线',
  icon: strikethrough,
  handler (editor) {
    editor.execCommand('strikeThrough')
  }
}
